import React, { useLayoutEffect, FC } from 'react';

import Button from '@components/Button';

import GoBackButton from './private/GoBackButton';
import Name from './private/Name';
import Rating from './private/Rating';
import Address from './private/Address';
import Special from './private/Special';
import Translation from './private/Translation';
import Undergrounds from './private/Undergrounds';
import Schedule from './private/Schedule';
import Phone from './private/Phone';
import Workload from './private/Workload';
import CloseInfo from './private/CloseInfo';
import Service from './private/Service';
import Header from './private/Header';
import MobileShowMapBtn from './private/MobileShowMapBtn';

import st from './ShortInfo.module.css';

type ShortInfoProps = {
  office: any;
  service?: any;
  onBack: () => void;
  onServicesCatalogOpen: () => void;
};

const ShortInfo: FC<ShortInfoProps> = ({
  office,
  service = null,
  onBack,
  onServicesCatalogOpen,
}) => {
  useLayoutEffect(
    () => () => {
      document.body.classList.remove('scroll_disabled');
    },
    []
  );

  const {
    rating,
    address,
    schedule,
    phone,
    status,
    id,
    type,
    translation,
    isVirtual,
  } = office;
  const isClosed = status === 'CLOSE';

  return (
    <div className={st.container} data-testid="shortInfo">
      <Header onBack={onBack} />

      <div className={st.content}>
        <div className={st.info}>
          <div className={st.mainInfo}>
            <GoBackButton onClick={onBack} />

            <Name isDetailed={false} isClosed={isClosed} office={office} />

            {!isClosed && (
              <div className={st.icons}>
                {!isVirtual && <Rating rating={rating} />}
                <Special office={office} />
                <Translation
                  officeId={id}
                  isDefaultOffice={type === 'default'}
                  camerasUrl={translation}
                />
              </div>
            )}

            <Address isClosed={isClosed} address={address} />

            <MobileShowMapBtn />
          </div>
          {!isClosed ? (
            <>
              <Undergrounds address={address} />

              <Schedule schedule={schedule} />

              <Phone phone={phone} />

              {service ? (
                <Service
                  service={service}
                  office={office}
                  onCatalogOpen={onServicesCatalogOpen}
                />
              ) : (
                <div className={st.serviceButton}>
                  <Button
                    dataTestId="openModalButton"
                    onClick={onServicesCatalogOpen}
                  >
                    Выбрать услугу
                  </Button>
                </div>
              )}
            </>
          ) : (
            <CloseInfo office={office} />
          )}
        </div>
        {!isClosed && <Workload officeId={id} schedule={schedule} />}
      </div>
    </div>
  );
};

export default ShortInfo;
